import type { ChatCommand } from '@game/game-data';
import type { PanelDimensions, PanelPosition } from '@game/ui';

import { capitaliseFirstLetter } from '@util/capitaliseFirstLetter';
import { defaultChatDimensions, defaultChatPosition } from '@store/persistentState';
import { persistentStore } from '@store/persistentStore';

export const localChatCommands: ChatCommand[] = [
  {
    name: 'clearChatInputHistory',
    helpText: 'Clears your chat input history buffer',
    requiredRoles: ['user'],
    localCommand: true,
  },
  {
    name: 'resetChatPanel',
    helpText: 'Sets your chat panel to its default position and size',
    requiredRoles: ['user'],
    localCommand: true,
  },
];

export function isLocalCommand(commandName: ChatCommand['name']): commandName is ChatCommand['name'] {
  return localChatCommands.some((localChatCommand) => localChatCommand.name === commandName);
}

function resetPanel(panelName: string, defaultDimensions: PanelDimensions, defaultPosition: PanelPosition): void {
  persistentStore.setState({ [`${panelName.toLowerCase()}Dimensions`]: defaultDimensions });
  persistentStore.setState({ [`${panelName.toLowerCase()}Position`]: defaultPosition });
  persistentStore.setState({ [`show${capitaliseFirstLetter(panelName)}Panel`]: true });
}

export function handleLocalCommand(commandName: ChatCommand['name']): void {
  switch (commandName) {
    case 'clearChatInputHistory': {
      persistentStore.setState({ inputHistory: [] });
      break;
    }

    case 'resetChatPanel': {
      resetPanel('chat', defaultChatDimensions, defaultChatPosition);

      break;
    }
    default: {
      break;
    }
  }
}
